import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, CircleCheck, FileText, MapPin, ShieldCheck, Sparkles, Star, Zap } from 'lucide-react';
import { ScrollButton } from '../CtaButton';
import { Reveal } from '../Reveal';
import { MOCKUP_URL } from '../../data/config';
const insignias = [{
  icon: FileText,
  label: 'PDF digital'
}, {
  icon: Zap,
  label: 'Acceso inmediato'
}, {
  icon: Sparkles,
  label: 'Todos los niveles'
}, {
  icon: ShieldCheck,
  label: 'Garantía 7 días'
}];
const autoridad = [{
  valor: '+300',
  label: 'profes confían',
  icon: CircleCheck,
  iconClasses: 'bg-bordo/10 text-bordo'
}, {
  valor: '7+5',
  label: 'Tomos + Bonos',
  icon: BookOpen,
  iconClasses: 'bg-verde/10 text-verde'
}, {
  valor: '4.9',
  suffix: '/5',
  label: 'valoración',
  icon: Star,
  iconClasses: 'bg-amber-50 text-amber-400',
  rating: true
}, {
  valor: 'AR',
  label: 'Todo el país',
  icon: MapPin,
  iconClasses: 'bg-blue-50 text-blue-500'
}];
export function Hero() {
  return <header className="w-full bg-crema px-4 pb-16 pt-10 sm:px-6 sm:pt-14 lg:pb-24" data-id="element-142" data-mp="9lpz0ix3b5xv">
      <div className="mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-143" data-mp="4n51ir9830d4">
        <Reveal data-id="element-144" data-mp="3vvskx1nwkdi1">
          <span className="inline-block rounded-full bg-bordo/10 px-4 py-2 text-[10px] font-bold uppercase tracking-[0.14em] text-bordo ring-1 ring-bordo/15 sm:text-xs" style={{
          fontSize: "10px"
        }} data-id="element-145" data-mp="3vvarsdwjefec">
            PROFES DE TELAS RESUELTO™ — SISTEMA COMPLETO
          </span>
        </Reveal>

        <Reveal delay={0.05} data-id="element-146" data-mp="nfr2tr2wfj53">
          <h1 className="mt-6 font-display text-[2rem] font-bold leading-[1.15] text-bordo sm:text-5xl lg:text-6xl" style={{
          fontSize: "28px"
        }} data-id="element-147" data-mp="nhjyycfvykyu">
            Todo tu año de clases de telas resuelto.
          </h1>
        </Reveal>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="mt-8 w-full" data-id="element-148" data-mp="1b5bnqfim4qh0">
          <img src={MOCKUP_URL} alt="Mockup del megapack Profes de Telas Resuelto: libro principal, 7 tomos y 5 bonos" width={620} height={620} className="mx-auto h-auto w-[300px] max-w-full sm:w-[420px] lg:w-[580px]" loading="eager" data-id="element-149" data-mp="30mypuhruz3g0" />
        </motion.div>

        <Reveal delay={0.05} data-id="element-150" data-mp="2vt4atrn77cn9">
          <p className="mt-6 font-display text-lg font-bold text-bordo sm:text-2xl" style={{
          fontSize: "13px",
          width: "355px",
          fontWeight: "900"
        }} data-id="element-151" data-mp="2hvpes42fw6mb">
            7 Tomos · 60+ Clases · 5 Bonos · 12 Meses de planificación.
          </p>
        </Reveal>

        <Reveal delay={0.08} data-id="element-152" data-mp="27yt69ycjjkhr">
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-tintasuave sm:text-lg" data-id="element-153" data-mp="27zmc8x3oe5yu">
            Tu año completo de clases de telas listo: fundamentos, planificación por niveles, gestión,
            seguridad, marketing y mucho más. Sin improvisar nunca más.
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-154" data-mp="1vn0l9dowr0qj">
          <ul className="mt-7 flex flex-wrap items-center justify-center gap-2.5" data-id="element-155" data-mp="1vm8v4ie2xv7n">
            {insignias.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-2 rounded-full border border-dorado/50 bg-white px-3.5 py-2 text-xs font-semibold text-tinta shadow-sm sm:text-sm" style={{
            fontSize: "11px"
          }} data-id="element-156" data-mp="1qluon4s4mtbq">
                <Icon className="h-4 w-4 text-verde" aria-hidden="true" data-id="element-157" data-mp="20kaivgmgaipg" />
                {label}
              </li>)}
          </ul>
        </Reveal>

        <Reveal delay={0.12} data-id="element-158" data-mp="2abdh8anzwjl1">
          <div className="mt-9 w-full" data-id="element-159" data-mp="2ae9dzvo3x27w">
            <ScrollButton targetId="oferta" className="px-8 py-5 text-sm sm:text-lg" data-id="element-160" data-mp="2oby2ddhdurhp">
              💥 QUIERO MI PROFES DE TELAS RESUELTO
            </ScrollButton>
            <p className="mt-4 text-xs text-tintasuave sm:text-sm" data-id="element-161" data-mp="txnasx9elj88">
              Pago 100% seguro · Mercado Pago | Tarjeta | Transferencia
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.14} className="w-full" data-id="element-162" data-mp="p0wwaed8yvox">
          <ul className="mt-10 grid w-full grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-5" data-id="element-163" data-mp="qepkicdm3csj">
            {autoridad.map(({
            valor,
            suffix,
            label,
            icon: Icon,
            iconClasses,
            rating
          }) => <li key={label} className="flex min-h-[190px] flex-col items-center justify-center rounded-2xl border border-black/[0.06] bg-white px-3 py-6 text-center shadow-[0_4px_14px_rgba(17,24,39,0.06)] sm:min-h-[220px] sm:px-5 sm:py-7" data-id="element-164" data-mp="10ddrmg4267hg">
                <span className={`flex h-12 w-12 items-center justify-center rounded-full sm:h-14 sm:w-14 ${iconClasses}`} data-id="element-165" data-mp="co2wbe5h95ap">
                  <Icon className={`h-6 w-6 sm:h-7 sm:w-7 ${rating ? 'fill-current' : ''}`} strokeWidth={2} aria-hidden="true" data-id="element-166" data-mp="hme7ptbf7nv1" />
                </span>
                <p className="mt-5 font-sans text-3xl font-bold leading-none text-tinta sm:text-4xl" data-id="element-167" data-mp="mfyxiy2v1bj5">
                  {valor}
                  {suffix && <span className="ml-0.5 text-lg font-medium text-tintasuave sm:text-xl" data-id="element-168" data-mp="3q2fnuycv685c">{suffix}</span>}
                </p>
                {rating && <span className="mt-2 flex gap-0.5 text-amber-400" aria-label="5 de 5 estrellas" data-id="element-169" data-mp="275s2qehjptt3">
                    {Array.from({
                length: 5
              }).map((_, index) => <Star key={index} className="h-3.5 w-3.5 fill-current sm:h-4 sm:w-4" aria-hidden="true" data-id="element-170" data-mp="1y5v71swqnuoj" data-mpi={index} />)}
                  </span>}
                <p className={`${rating ? 'mt-1.5' : 'mt-3'} text-xs font-medium text-tintasuave sm:text-base`} data-id="element-171" data-mp="1o9iitajyq916">{label}</p>
              </li>)}
          </ul>
        </Reveal>
      </div>
    </header>;
}